<template>
  <div class="inventory-item-container" style="position: relative;">
    <div v-if="unavailable" class="inventory-item-unavailable-container">
      <div>This Item is No Longer Available</div>
    </div>
    <div v-if="draggable" class="inventory-drag-box">
      <v-icon>fas fa-arrows-alt</v-icon>
    </div>
    <div class="inventory-item-image" style="position: relative;" :style="{backgroundImage: 'url(' + variation.image + ')', opacity: (unavailable ? .5 : 1)}">
      <div v-if="showBuy || showOwned" class="inventory-button-container">
        <v-layout row>
          <v-flex v-if="showBuy">
            <v-tooltip top>
              <v-btn
                slot="activator"
                color="primary" 
                small style="min-width: 0px;" 
                @click="$emit('on-buy-now')"
                :disabled="buyNowUnavailable"
              >
                Buy
              </v-btn>
              <span v-if="buyNowUnavailable">Item is Unavailable for Purchase</span>
              <span v-else>Purchase item to keep it forever</span>
            </v-tooltip>
          </v-flex>
          <v-flex v-if="showOwned">
            <v-btn flat color="primary" small style="min-width: 0px;" @click="$emit('on-owned')"><v-icon>fas fa-receipt</v-icon></v-btn>
          </v-flex>
          <v-flex>

          </v-flex>
        </v-layout>
      </div>
    </div>
    <template v-if="!condensed">
      <v-divider class="ma-3" :style="{opacity: (unavailable ? .5 : 1)}"></v-divider>
      <div class="inventory-item-summary mx-3" :style="{opacity: (unavailable ? .5 : 1)}">
        <v-tooltip top>
          <div slot="activator" class="sans-serif nowrap" style="font-size: 1.3em; font-weight: bold;">{{ item.brand + ' ' + item.category }}</div>
          <span>{{ item.brand + ' ' + item.category }}</span>
        </v-tooltip>
        <v-tooltip top>
          <div slot="activator" class="body-1 my-1 nowrap">{{ item.name }}</div>
          <span>{{ item.name }}</span>
        </v-tooltip>
        <div class="body-1 my-1">Size: {{ variation.size }}</div>
        <div class="body-1 my-1" v-if="!buyNowSummary"><strong>${{ variation.tp_price | currency }}</strong> | <del>${{ variation.retail_price | currency }}</del></div>
      </div>
      <div v-if="detail" class="inventory-item-detail mx-3">
        <div class="body-1 my-1">Material: {{ stringifyRelation(item.materials) }}</div>
        <div class="body-1 my-1">Color: {{ stringifyRelation(variation.colors) }}</div>
        <div class="body-1 my-1">Item ID: {{ variation.id }}</div>
      </div>
    </template>
    <template v-if="buyNowSummary">
      <div class="text-xs-center">
        ${{ variation.tp_purchase_price | currency }}
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'InventoryItem',
  props: {
    'item': Object,
    'detail': Boolean,
    'draggable': Boolean,
    'condensed': Boolean,
    'showBuy': Boolean,
    'showOwned': Boolean,
    'buyNowSummary': Boolean,
    'buyNowUnavailable': Boolean,
    'ignoreAvailability': Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    variation: function() {
      if(!this.item.recommended) return {};
      for(let i = 0; i < this.item.variations.length; i++) {
        if(this.item.variations[i].id == this.item.recommended) return this.item.variations[i];
      }
    },
    unavailable: function() {
      if(this.ignoreAvailability) return false;
      if(!this.variation.available) return true;
      if(!this.variation.stock_quantity || this.variation.stock_quantity <= 0) return true;
      return false;
    }
  },
  methods: {
    stringifyRelation: function(rel) {
      let arr = [];
      if(!rel) return '';
      for(let i = 0; i < rel.length; i++) {
        arr.push(rel[i].name);
      }
      return arr.join('/');
    }
  }
}
</script>

<style lang="scss" scoped>
  .inventory-drag-box {
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: #CCC;
    padding: 5px;
    z-index: 4;
    cursor: move;
  }

  .inventory-button-container {
    position: absolute;
    bottom: 0px; 
    left: 0px;
    right: 0px;
    z-index: 3;
  }

  .inventory-buy-summary {
    height: 300px;
    padding: 0px;
  }

  .inventory-item-unavailable-container {
    position: absolute;
    top: 40px; left: 0px; right: 0px;
    z-index: 2;

    text-align: center;
    >div {
      display: inline-block;
      padding: 10px 20px;
      background-color: rgba(255,0,0,.65);
      margin: 0 auto;
      color: #FFF;
    }
  }
</style>